import Vue from 'vue'
import {sync} from 'vuex-router-sync'
import App from './components/App'
import router from './router'
import store from './store'
import myPdf from '@/assets/keeping_secrets_lessons_learned_from_securing_github_rubykaigi_2025.pdf';
// import 'babel-polyfill'

sync(store, router)

// require('es6-promise').polyfill()
require('./css/style.scss')

const app = new Vue({
  router,
  store,
  components: { App },
  template: '<App/>'
})

export {app, router, store}
